import {fade} from '@material-ui/core';

export default (theme) => ({
    root: {
        flexGrow: 1,
        position: 'fixed',
        zIndex: 1300,
        width: '100%',
        top: 0
    },
    menuSection: {
        display: 'flex',
        alignItems: 'center',
    },
    menuButton: {
        marginRight: theme.spacing(5),
        transform: 'rotate(180deg)',
        [theme.breakpoints.up('sm')]: {
            '& span svg': {
                width: '34px',
                height: '34px',
            },
        },
    },
    title: {
        fontFamily: '"Montserrat", sans-serif',
        flexGrow: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'none',
        maxWidth: '335px',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
    verticalLine: {
        width: '2px',
        height: '34px',
        backgroundColor: '#7986cb',
        margin: `0px ${theme.spacing(4)}px`,
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
    },

    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: 'auto',
        },
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '20ch',
        },
    },

    userSection: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        },
    },
    language: {
        alignItems: 'center',
        color: '#ffffff',
        marginRight: theme.spacing(2.5),
        '& span': {
            cursor: 'pointer',
        },
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        },
    },
    notification: {
        marginRight: theme.spacing(2.5),

        '& .MuiBadge-badge': {
            right: 'unset',
            left: 0,
            color: '#212121',
            backgroundColor: '#e8b32e',
            fontWeight: 'bold'
        },

        '& div[role="tooltip"]': {
            zIndex: 10000
        }
    },
    notification_paper: {
        // background: 'transparent',
        // paddingTop: 20,
        borderRadius: 5,
    },
    notification_list: {
        minWidth: 500,
        borderRadius: 5,
        boxShadow: '0 1px 2px 0 rgb(158 158 158 / 50%)',
        border: '1px solid #f5f5f5',
        position: 'relative',

        [theme.breakpoints.down(500)]: {
            width: '100%',
            minWidth: 'unset',
        }
    },
    notification_list_notFound: {
        minHeight: 100,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '& .MuiTypography-root': {
            color: '#9e9e9e',
        }
    },
    notification_notFound: {
        color: '#9e9e9e',
    },
    notification_label: {
        padding: 16,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        borderBottom: '1px solid #f5f5f5',

        '&:hover': {
            backgroundColor: '#e8eaf6',
        },
    },
    notification_label__icon: {
        '& .MuiSvgIcon-root': {
            width: 34,
            height: 34,
            color: '#9e9e9e',
            marginRight: 16
        }
    },
    notification_label__text: {},
    show_more_notification: {
        padding: 16,
        color: '#3f51b5',
        cursor: 'pointer',
    },

    tariffWrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        marginRight: theme.spacing(4),
        [theme.breakpoints.down(391)]: {
            display: 'none',
        },
    },

    userMenu: {
        display: 'flex',
        alignItems: 'center',
    },
});
